import React, { lazy, useLayoutEffect, useState } from "react";
import Logo from "../components/Logo";
import { useSearchParams } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import axios from "axios";
import NoMatch from "../components/NoMatch";


const AAdharVerification = lazy(() => import("./AAdharVerification"));
const Licence = lazy(() => import("./Licence"));
const FaceLivenessMobile = lazy(() => import("./FaceLivenessMobile"));


export let clientSecret = "";
export let token = "";

const layoutObj = {
  uuid: <AAdharVerification />,
  dl: <Licence />,
};

export default function Layout() {
  const [loading, setLoading] = useState(false);
  const [queryParameters] = useSearchParams();
  const [validateToken, setValidateToken] = useState(false);
  const [componentLoaded, setComponentLoaded] = useState(null);
  const getFacePayParam = queryParameters.get("facepay");
  const sessionId = queryParameters.get("sessionId");

  useLayoutEffect(() => {
    if (sessionId) return;
    setLoading(true);
    const params = queryParameters.get("token");
    axios
      .post(`/api/v2/external/gateway/verify/token/`, {
        token: params,
      })
      .then(function (response) {
        token = params;
        clientSecret = response?.data?.data?.client_secret;
        setValidateToken(response?.status);
        setComponentLoaded(response?.data?.data?.verification_product);
        console.log(response?.data?.data);
      })
      .catch(function (error) {
        setValidateToken(error?.response?.data?.status);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (sessionId?.length > 0) {
    return (
      <>
        <div className="content-wrapper">
          <div className="content-body">
            <FaceLivenessMobile />
          </div>
        </div>
      </>
    );
  }

  return (
    <>{!sessionId?.length && <div className="content-wrapper">
      {!getFacePayParam && (
        <div className="top-nav">
          <div style={{ width: "150px", height: "100%" }}>
            <Logo fill="#000" />
          </div>
        </div>
      )}

      <div className="content-body">
        {loading && !validateToken ? (
          <div className="loader">
            <Spinner animation="border" variant="light" />
          </div>
        ) : validateToken ? (
          layoutObj[componentLoaded]
        ) : (
          <NoMatch />
        )}
      </div>
    </div>}
      
    </>
  );
}
